import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import HttpUtil from '../../Util/httpUtil';
import ReactTable from 'react-table';
import Moment from 'moment';
import ModuloEfd from './../Modulo/ModuloEfd';
import ValidacaoItem from './ValidacaoItem';
import OpcoesDownloadItem from './../Modulo/OpcoesDownloadItem';
import RemoverResultadoItem from './../Modulo/RemoverResultadoItem';
import BotaoVisualizarItem from './../Arquivos/BotaoVisualizar';
import '../../_Content/css/historico-resultado.css';
import Config from '../../Util/config';
import { withRouter } from 'react-router-dom';
import RemoverHistorico from '../Modulo/RemoverHistorico';

const idUsuario = localStorage.getItem('CodUsuario');
const token = localStorage.getItem("Token");
const isPro = localStorage.getItem("isPro") === 'true';

class HistoricoResultado extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showData: [],
            sorted: [],
			defaultSorted: [{ id: 'dataFormat', desc: true }],
            filteredManual: [],
			pages: 0,
            totalDataRows: 0,
			listaEmpresas: [],
			listaCompetencias: [],
			listaValidacoes: [
				{
					Key: 'basica',
					Value: 'Básica'
				},
				// {
				// 	Key: 'estados',
				// 	Value: 'Estados'
				// },
				{
					Key: 'inteligente',
					Value: 'Inteligente'
				},
				{
					Key: 'simples-nacional',
					Value: 'Simples Nacional'
				}
			],
			loading: true,
			mostrarContribuicoes: true,
			mostrarECF: true,
			mostrarECD: true,
			mostrarFiscal: true,
			mostrarSimplesNacional: true,
			columns: [
				{
					Header: 'Módulo',
					accessor: 'moduloEfd',
					maxWidth: 140,
					Cell: row => (
						<ModuloEfd
							value={
								row.original.tipoValidacao && row.original.tipoValidacao.includes(
									'simples-nacional'
								)
									? 'SimplesNacional'
									: row.value
							}
						/>
					)
				},
				{
					Header: 'Empresa',
					className: 'txt',
					accessor: 'Contribuinte'
				},
				{
					Header: "CNPJ",
					className: "text-center txt",
					accessor: "CnpjCpf",
					maxWidth: 120,
				},
				{
					Header: 'Competência',
					accessor: 'DatIni',
					className: 'text-center txt',
					maxWidth: 120,
					Cell: row => (
						<span>
                            {row.original.moduloEfd.toLowerCase() == "ecf"
                                || row.original.moduloEfd.toLowerCase() == "ecd" ?
								Moment(row.value, 'D/M/YYYY').format('Y')
							 :
							 	Moment(row.value, 'D/M/YYYY').format('MMM - Y')
							}							
						</span>
					)
				},
				{
					Header: 'Última atualização',
					accessor: 'dataFormat',
					className: 'text-center txt',
					maxWidth: 140,
					Cell: row => (
						<span>
							{Moment(row.value).format('D/MM/Y [às] HH[h]mm')}
						</span>
					)
				},
				{
					Header: 'DivergênciasFiltroItensEmDivergencia',
					accessor: 'totalDivergencias',
					className: 'text-center txt',
					maxWidth: 100,
					Cell: row => (
						<div>
							{row.original.totalDivergencias}
						</div>
					)
				},
				{
					Header: 'Validações',
					accessor: 'tipoValidacao',
					className: 'text-center',
					maxWidth: 120,
					Cell: row => (
						<ValidacaoItem id={row.index} value={row.value} />
					)
				},
				{
					Header: 'Ações',
					Filterable: false,
					sortable: false,
					maxWidth: 70,
					className: 'text-center',
					Cell: row => (
						<div>
							<OpcoesDownloadItem
								idArquivo={row.original.id}
								moduloEfd={row.original.moduloEfd}
								tipoValidacao={row.original.tipoValidacao}
								status={row.original.status}
								origem={'historico'}
							/>
							{isPro === false &&
								<RemoverResultadoItem
									idArquivo={row.original.id}
									moduloEfd={row.original.moduloEfd}
									action={this.reactTable.fireFetchData}
									onLoading={this.onLoading}
								/>
							}
						</div>
					)
				},
				{
					Header: '',
					Filterable: false,
					sortable: false,
					maxWidth: 120,
					className: 'text-center',
					Cell: row => (
						<div>
							<BotaoVisualizarItem data={row.original} origem="historico" />
						</div>
					)
				}
			],
			showFilter: false,
			filtroContribuinte: 'todos',
			filtroCompetencia: 'todos',
			//filtroDe: '',
			//filtroAte: '',
			filtroValidacoes: 'todos',
			pageSize: 10,
		};

		this.reactTable = React.createRef();
		this.checkMostrarECF = React.createRef();
		this.checkMostrarECD = React.createRef();
		this.checkMostrarFiscal = React.createRef();
		this.checkMostrarSimplesNacional = React.createRef();
		this.checkMostrarContribuicoes = React.createRef();
	}

	onLoading = isLoading => {
		this.setState({ loading: isLoading });
	};

	onFetchData = (state) => {		
		this.setState({ loading: true });
		this.requestData(state).then(res => {

			var empresas = res.ComboList.map(item => {
				return item.Contribuinte;
			});
			
			var uniqueEmpresas = Array.from(new Set(empresas)).sort((a, b) =>
				a.localeCompare(b)
			);

			var competencias = res.ComboList.map(item => {
				return item.DatIni; // [ item.DatIni, Moment(item.DatIni, 'D/M/YYYY').format('MMM - Y') ];
			});

			var uniqueCompetencias = Array.from(new Set(competencias)).sort(
				(a, b) => Moment(a, 'D/M/YYYY').format('MMM - Y').localeCompare(Moment(b, 'D/M/YYYY').format('MMM - Y'))
			);

			uniqueCompetencias = uniqueCompetencias.map(item => {
				return { value: Moment(item, 'D/M/YYYY').format('MM/YYYY'), text: Moment(item, 'D/M/YYYY').format('MMM - Y') };
			});

			this.setState({
				showData: res.Data,
				totalDataRows: res.TotalCount,
				pages: Math.ceil(res.TotalCount / this.state.pageSize),
				loading: false,
				listaEmpresas: uniqueEmpresas,
				listaCompetencias: uniqueCompetencias
			});
		});
	}

	requestData = (state) => {
        let { sorted, defaultSorted } = state;
		let { filteredManual } = this.state;
		
        if(typeof sorted === "undefined" || sorted == null || sorted.length == 0) {
            sorted = defaultSorted;
        }

		return new Promise((resolve, reject) => {
			let url = `${Config.urls.API_URL_BASE}HistoricoArquivos/BuscarHistoricoResultados/`;

			HttpUtil.eco_POST(
				url,
				{
					idUsuario: idUsuario,
					token: token,
					currentPage: state.page,
					pageSize: state.pageSize,
					sortedJson: `${JSON.stringify(sorted)}`,
					filterJson: `${JSON.stringify(filteredManual)}`
				},
				response => {
					resolve({ Data: response.data.Data, TotalCount: response.data.TotalCount, ComboList: response.data.ComboList });
				},
				(err) => {
					console.log(err);
				}
			);
		});
	};

	visualizaResultado = row => {
		let idArquivo = row.id;
		let moduloEfd = row.moduloEfd;
		let tipoValidacao = row.tipoValidacao;

		this.props.history.push(
			`/resultado/${idArquivo}/${moduloEfd}/${tipoValidacao}/${true}`
		);
	};

	visualizaErroEstrutura = row => {
		let idArquivo = row.id;
		let moduloEfd = row.moduloEfd;
		let tipoValidacao = row.tipoValidacao;

		this.props.history.push(`/resultadoErros/${idArquivo}/${moduloEfd}`);
	};

	setarBotoes = row => {
		if (row.original.status == 'Finalizado') {
			return (
				<button
					className="ecobtn fit vazado verde"
					style={{ width: '100px' }}
					onClick={e => this.visualizaResultado(row.original)}>
					Visualizar
				</button>
			);
		} else {
			return (
				<button
					className="ecobtn fit vazado vermelho"
					style={{ width: '100px' }}
					onClick={e => this.visualizaErroEstrutura(row.original)}>
					Revisar
				</button>
			);
		}
	};

	moduloClicado = (modulo, checked) => {
		switch (modulo) {
			case 'ECF':
				this.setState(
					{ mostrarECF: checked },
					this.atualizarListaFiltrada
				);
				break;
			case 'ECD':
				this.setState(
					{ mostrarECD: checked },
					this.atualizarListaFiltrada
				);
				break;
			case 'Fiscal':
				this.setState(
					{ mostrarFiscal: checked },
					this.atualizarListaFiltrada
				);
				break;
			case 'SimplesNacional':
				this.setState(
					{ mostrarSimplesNacional: checked },
					this.atualizarListaFiltrada
				);
				break;
			default:
				this.setState(
					{ mostrarContribuicoes: checked },
					this.atualizarListaFiltrada
				);
		}
	};

	atualizarListaFiltrada = () => {
		// var filtroDe =
		// 	this.state.filtroDe == '' ? '' : new Date(this.state.filtroDe);
		// var filtroAte =
		// 	this.state.filtroAte == '' ? '' : new Date(this.state.filtroAte);

		let filteredManual = [];
		let { mostrarContribuicoes, mostrarFiscal, mostrarSimplesNacional, mostrarECF, mostrarECD, filtroContribuinte, filtroCompetencia, filtroValidacoes } = this.state;

		if (filtroContribuinte != 'todos') {
			filteredManual.push({ id: 'Contribuinte', value: filtroContribuinte });
		}
		if (filtroCompetencia != 'todos') {
			filteredManual.push({ id: 'DatIni', value: filtroCompetencia });
		}
		if (filtroValidacoes != 'todos') {
			filteredManual.push({ id: 'tipoValidacao', value: filtroValidacoes });			
		}
		if (!mostrarSimplesNacional) {
			filteredManual.push({ id: 'moduloEfd', value: 'simples-nacional' });
		}
		if (!mostrarECF) {
			filteredManual.push({ id: 'moduloEfd', value: 'ECF' });			
		}
		if (!mostrarECD) {
			filteredManual.push({ id: 'moduloEfd', value: 'ECD' });			
		}
		if (!mostrarFiscal) {
			filteredManual.push({ id: 'moduloEfd', value: 'Fiscal' });			
		}
		if (!mostrarContribuicoes) {
			filteredManual.push({ id: 'moduloEfd', value: 'Contribuicao' });			
		}
		this.setState({ filteredManual }, this.reactTable.fireFetchData);
		// var lista = this.state.lista.filter(item => {
		// 	return (item.Contribuinte == contribuinte || contribuinte == "todos") &&

		// 		((mostrarSimplesNacional && item.moduloEfd == "Fiscal" && item.tipoValidacao.includes("simples-nacional"))
		// 			|| (mostrarFiscal && item.moduloEfd == "Fiscal" && !item.tipoValidacao.includes("simples-nacional"))
		// 			|| (mostrarContribuicoes && item.moduloEfd == "Contribuicao")
		// 			|| (mostrarECF && item.moduloEfd == "ECF")) &&

		// 		(Moment(item.DatIni, "D/M/YYYY").format("MMM - Y") == competencia || competencia == "todos") &&

		// 		(Moment(item.DatIni, "dd/MM/yyyy")._d >= filtroDe || filtroDe == "") &&
		// 		(Moment(item.DatFin, "dd/MM/yyyy")._d <= filtroAte || filtroAte == "") &&

		// 		((item.tipoValidacao.includes(filtroValidacoes)) || filtroValidacoes == "todos")
		// });
	};

	limparFiltros = () => {
		let { mostrarContribuicoes, mostrarFiscal, mostrarSimplesNacional, mostrarECF, mostrarECD, filtroContribuinte, filtroCompetencia, filtroValidacoes } = this.state;

		if ( mostrarContribuicoes != true 
			|| mostrarFiscal != true 
			|| mostrarSimplesNacional != true 
			|| mostrarECF != true 
			|| mostrarECD != true 
			|| filtroContribuinte != 'todos' 
			|| filtroCompetencia != 'todos' 
			|| filtroValidacoes != 'todos') {
				this.setState({ 
					mostrarContribuicoes: true,
					mostrarFiscal: true,
					mostrarSimplesNacional: true,
					mostrarECF: true,
					mostrarECD: true,
					filtroContribuinte: 'todos',
					filtroCompetencia: 'todos',
					// filtroDe: '',
					// filtroAte: '',
					filtroValidacoes: 'todos',
				 }, () => {
						this.checkMostrarECF.justCheck();
						this.checkMostrarECD.justCheck();
						this.checkMostrarFiscal.justCheck();
						this.checkMostrarSimplesNacional.justCheck();
						this.checkMostrarContribuicoes.justCheck();
						this.atualizarListaFiltrada();
					 }
				 );
		}
	};

	render() {
		return (
			<div>
				<Container>
					<Row>
						<Col>
							<section className="cabecalho">
								<Row>
									<Col md={7}>
										<label className="page-title">
											Histórico de Resultados
										</label>
									</Col>
								</Row>
							</section>
							<section className="opcoes">
								<Row>
									<Col lg={2} className="modulosTpsLbl">
										<label>Módulos:</label>
									</Col>
								</Row>
								<Row>
									<Col xl={6} lg={7}>
										<div className="modulo">
											<Row>
												<Col lg={3} xs={4} className="text-nowrap">
													<ModuloEfd ref={checkMostrarContribuicoes => {this.checkMostrarContribuicoes = checkMostrarContribuicoes}} value="Contribuicao" onUpdate={this.moduloClicado} checkable />
												</Col>
												<Col lg={2} xs={3} className="text-nowrap">
													<ModuloEfd ref={checkMostrarECF => {this.checkMostrarECF = checkMostrarECF}} value="ECF" onUpdate={this.moduloClicado} checkable />
												</Col>
												{/* Descomentar quando o projeto ECD entrar em produção */}
												<Col lg={2} xs={3} className="text-nowrap">
													<ModuloEfd ref={checkMostrarECD => {this.checkMostrarECD = checkMostrarECD}} value="ECD" onUpdate={this.moduloClicado} checkable />
												</Col>
												<Col lg={2} xs={3} className="text-nowrap">
													<ModuloEfd ref={checkMostrarFiscal => {this.checkMostrarFiscal = checkMostrarFiscal}} value="Fiscal" onUpdate={this.moduloClicado} checkable />
												</Col>
												<Col lg={2} xs={3} className="text-nowrap">
													<ModuloEfd ref={checkMostrarSimplesNacional => {this.checkMostrarSimplesNacional = checkMostrarSimplesNacional}} value="SimplesNacional" onUpdate={this.moduloClicado} checkable />
												</Col>
											</Row>
										</div>
									</Col>
									<Col lg={3}>
										<div className=" delete-historico form-inline">
											<label>{this.filtroValidacoes}Excluir histórico</label>
											<RemoverHistorico
												action={this.reactTable.fireFetchData}
												onLoading={this.onLoading}
											/>
										</div>
									</Col>
									<Col xl={2} lg={2} xs={6}>
										<div className="exibir form-inline">
											<label>Exibir:</label>
											<select className="ecoforms form-control" onChange={e => {
												this.setState({ pageSize: parseInt(e.target.value) });
											}}>
												<option value="10">10</option>
												<option value="25">25</option>
												<option value="50">50</option>
												<option value="100">100</option>
												<option value="1000">1000</option>
											</select>
										</div>
									</Col>
									<Col lg={1} xs={6}>
										<div className="filtrar" onClick={() => { this.setState({ showFilter: !this.state.showFilter }); }}>
											<i className="ecoico ecoico-filtro" />
											<span>Filtrar</span>
										</div>
									</Col>
								</Row>
								<section className="filterSection"
									style={this.state.showFilter ? { display: 'block' } : { display: 'none' }}>
									<Row>
										<Col md={4}>
											<label>EMPRESA</label>
											<select
												className="ecoforms"
												value={
													this.state
														.filtroContribuinte
												}
												onChange={e => {
													this.state.filtroContribuinte =
														e.target.value;
													this.atualizarListaFiltrada();
												}}>
												<option value="todos">
													Todos
												</option>
												{this.state.listaEmpresas.map(
													item => (
														<option
															key={item}
															value={item}>
															{item}
														</option>
													)
												)}
											</select>
										</Col>
										<Col md={3}>
											<label>COMPETÊNCIA</label>
											<select
												className="ecoforms"
												onChange={e => {
													this.state.filtroCompetencia =
														e.target.value;
													this.atualizarListaFiltrada();
												}}
												value={
													this.state.filtroCompetencia
												}>
												<option value="todos">
													Todas...
												</option>
												{this.state.listaCompetencias.map(
													item => (
														<option
															key={item.value}
															value={item.value}>
															{item.text}
														</option>
													)
												)}
											</select>
										</Col>
										{/* <Col className="col-xs-6">
											<label>PERÍODO</label>
											<input
												className="ecoforms"
												type="date"
												value={this.state.filtroDe}
												onChange={e => {
													this.state.filtroDe =
														e.target.value;
													this.atualizarListaFiltrada();
												}}
											/>
										</Col>
										<Col className="col-xs-6">
											<label>&nbsp;</label>
											<input
												className="ecoforms"
												type="date"
												value={this.state.filtroAte}
												onChange={e => {
													this.state.filtroAte =
														e.target.value;
													this.atualizarListaFiltrada();
												}}
											/>
										</Col> */}
										<Col md={3}>
											<label>VALIDAÇÕES</label>
											<select
												className="ecoforms"
												value={
													this.state.filtroValidacoes
												}
												onChange={e => {
													this.state.filtroValidacoes =
														e.target.value;
													this.atualizarListaFiltrada();
												}}>
												<option value="todos">
													Todas...
												</option>
												{this.state.listaValidacoes.map(
													item => (
														<option
															key={item.Key}
															value={item.Key}>
															{item.Value}
														</option>
													)
												)}
											</select>
										</Col>
										<Col md={2}>
											<button className="ecobtn fat vazado baby-blue limpaFiltro btn-block" onClick={this.limparFiltros}>Limpar Filtros</button>
										</Col>
									</Row>
								</section>
							</section>
							<section className="tabela-resultado">
								<ReactTable
									ref={reactTable => {this.reactTable = reactTable}}
									key={this.state.pageSize}
									manual
									data={this.state.showData}
									columns={this.state.columns}
									loading={this.state.loading}
									className="eco-react-table"
									pageSize={this.state.pageSize}
									pages={this.state.pages}
									defaultSorted={this.state.defaultSorted}
									showPagination={this.state.totalDataRows > this.state.pageSize}
									onFetchData={this.onFetchData}
									onSortedChange={(newSort, column) => { this.setState({ sorted: newSort }); }}
								/>
							</section>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

//export default HistoricoResultado;
export default withRouter(HistoricoResultado);



// WEBPACK FOOTER //
// ./src/Componente/HistoricoResultado/HistoricoResultado.jsx